let cartItemCount = document.getElementById("cart-item-count");
let cartItemCountMobile = document.getElementById("cart-item-count-mobile");
let cartItemCountMobileBottom = document.getElementById("cart-item-count-mobile-bottom");

function updateCartQuantity(e) {
  setTimeout(() => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let itemCount = data.item_count.toString();
        cartItemCountMobile.innerHTML = "(" + itemCount + ")";
        cartItemCountMobileBottom.innerHTML = "(" + itemCount + ")";
        cartItemCount.innerHTML = "(" + itemCount + ")";
      });
  }, 400);
}

function trackIntelligemsEvent(event) {
  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    event: event,
  });
}

window.addEventListener("cart:updated", (e) => {
  if(!!!e.detail.cart || !!!e.detail.id) return

  const currentItem = e.detail.cart.items?.find(x => x.variant_id === Number(e.detail.id))

  if(currentItem && !!!currentItem.selling_plan_allocation && currentItem.quantity >= 2) {
    trackIntelligemsEvent("Cart Discount Banner Displayed")
  }
})




